<template>
  <div class="page-forget-password">
    <div class="container">
      <div class="page-header">
        <h2>忘记密码</h2>
      </div>
      <div class="page-body">
        <step1 v-if="step === 1" :userType="userType" @next="onNext"></step1>
        <step2 v-if="step === 2" :phone="phone" :areaCode="areaCode" :email="email" :questions="questions" @next="onNext"></step2>
        <step3 v-if="step === 3" :token="token" :checkedToken="checkedToken"></step3>
      </div>
      <div class="page-footer" v-if="step === 2 && userType === 0">
        <div class="mod-tip">
          <a-icon type="exclamation-circle" theme="filled" />若以上密码找回方式已失效或未预留有效的手机号、邮箱、安全问题，您可以使用 <a href="#" @click="onAuthenticate">线上实名认证方式</a> 找回密码，或致电{{ app.name }}客服热线{{ app.hotline }}协助您重新设置密码。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import Step1 from './components/step1'
import Step2 from './components/step2'
import Step3 from './components/step3'
import fromApp from '@/utils/from'
import './index'

export default {
  data () {
    return {
      step: 1,
      userType: 0,
      token: '',
      phone: '',
      email: '',
      questions: [],
      checkedToken: '',
      app: null
    }
  },
  created () {
    const params = queryString.parse(location.search)

    if (params.userType && !isNaN(params.userType)) {
      this.userType = params.userType - 0
    }

    this.app = fromApp()
  },
  methods: {
    onNext (data) {
      if (this.step === 1) {
        this.token = data.token
        this.phone = data.phone || ''
        this.areaCode = data.areaCode || '86'
        this.email = data.email || ''
        this.questions = data.securityQuestions ? data.securityQuestions.map(item => {
          return {
            label: item.questionDesc,
            value: item.questionId
          }
        }) : []
      } else if (this.step === 2) {
        this.checkedToken = data
      }

      this.step = this.step + 1
    },
    onAuthenticate (e) {
      e.preventDefault()
      const { token } = this

      this.$router.push({
        path: '/authenticate-without-auth',
        query: {
          type: 'forgetPassword',
          token
        }
      })
    }
  },
  components: {
    Step1,
    Step2,
    Step3
  }
}
</script>
